<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="620px">
    <template slot="title">
      <span>{{ dialogTitle }}</span>
      <span v-if="readonly && form.materialReplaceId" class="title-actions">
        <el-button v-if="isAuth('base:materialReplace:update')" type="primary" size="small" @click="readonly = false">修改</el-button>
        <el-button v-if="isAuth('base:materialReplace:delete')" type="primary" size="small" @click="remove">删除</el-button>
      </span>
    </template>
    <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px" @keyup.enter.native="readonly ? undefined : save()">
      <el-form-item label="主物料" prop="materialId">
        <el-select v-model="form.materialId" :disabled="readonly" style="width:100%" filterable>
          <el-option v-for="item in materials" :key="item.materialId" :label="item.materialCode + ' / ' + item.materialName" :value="item.materialId" />
        </el-select>
      </el-form-item>
      <el-form-item label="替代物料" prop="replaceMaterialId">
        <el-select v-model="form.replaceMaterialId" :disabled="readonly" style="width:100%" filterable>
          <el-option v-for="item in materials" :key="'r' + item.materialId" :label="item.materialCode + ' / ' + item.materialName" :value="item.materialId" />
        </el-select>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number v-model="form.sort" :disabled="readonly" :min="0" :step="1" style="width:100%" />
      </el-form-item>
      <el-form-item label="替代比例" prop="replaceRatio">
        <el-input-number v-model="form.replaceRatio" :disabled="readonly" :min="0.01" :step="0.01" :precision="2" style="width:100%" />
        <div v-if="!readonly" class="form-tip">1 表示 1:1；2 表示 1 件主料按 2 件替代料换算（须 &gt; 0）</div>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" :disabled="readonly" type="textarea" :rows="3" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  data() {
    return {
      visible: false, readonly: false, form: {}, materials: [], permCodes: [],
      rules: {
        materialId: [{ required: true, message: '主物料不能为空', trigger: 'change' }],
        replaceMaterialId: [{ required: true, message: '替代物料不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看替代料'
      return this.form.materialReplaceId ? '修改替代料' : '新增替代料'
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(row, readonly, materialId) {
      this.loadMaterials()
      this.readonly = !!readonly
      this.visible = true
      const blank = () => ({ materialId: materialId || '', sort: 0, replaceRatio: 1 })
      const apply = data => {
        this.form = Object.assign(blank(), data || {}, {
          sort: (data && data.sort) || 0,
          replaceRatio: data && data.replaceRatio != null ? Number(data.replaceRatio) : 1
        })
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }
      if (!row || !row.materialReplaceId) {
        apply(blank())
        return
      }
      request.get('/base/materialReplace/info/' + row.materialReplaceId).then(res => apply(res.data || row)).catch(() => apply(row))
    },
    loadMaterials() {
      request.post('/base/material/page', { currentPage: 1, pageSize: 500 }).then(res => {
        this.materials = (res.data && res.data.list) || []
      }).catch(() => {})
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (this.form.materialId === this.form.replaceMaterialId) {
          this.$message.warning('主物料和替代物料不能相同')
          return
        }
        request.post('/base/materialReplace/' + (this.form.materialReplaceId ? 'update' : 'save'), this.form).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    },
    remove() {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        request.post('/base/materialReplace/delete', { materialReplaceId: this.form.materialReplaceId }).then(() => {
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.title-actions { float: right; margin-right: 28px; }
.form-tip { font-size: 12px; color: #909399; line-height: 1.4; margin-top: 4px; }
</style>
